export const environment = {
  production: true,
  apiUrl: 'https://am-mis-stage-api.prozrenie.ru/api/v1',
  useDemoData: false,
};
